import React from 'react';
import { useHistory, useLocation } from 'react-router';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PendingIcon from '@material-ui/icons/Timer';
import ErrorIcon from '@material-ui/icons/Error';
import { RemoveCircle } from '@material-ui/icons';
import AppTable from '../../basic/AppTable';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

export const VersionStatusIcon = (
  {
    status,
  },
) => {
  if ('accepted' === status) {
    return <CheckCircleIcon style={ { color: 'green' } } />;
  }

  if ('pending' === status) {
    return <PendingIcon style={ { color: 'orange' } } />;
  }

  if ('past_version' === status) {
    return <RemoveCircle style={ { color: 'gray' } } />;
  }

  if ('rejected' === status) {
    return <ErrorIcon color='error' />;
  }

  return <p>{status}</p>;
};

const tableColumns = [
  { id: 1, label: 'ID', field: 'id' },
  { id: 2, label: 'Covariance ID', field: 'covariance_id' },
  { id: 3,
    label: 'Status',
    field: 'status',
    customRenderer({ value: versionStatus }) {
      return <VersionStatusIcon status={ versionStatus } />;
    } },
  { id: 4, label: 'Created at', field: 'created_at' },
  { id: 5, label: 'Timestamp', field: 'timestamp' },
];

const VersionSelectTable = (
  {
    race,
    device,
    trait,
  },
) => {
  const history = useHistory();
  const location = useLocation();
  const handleViewAction = (e, versionId) => {
    if (!versionId) {
      throw new Error('Please provide a version id');
    }
    return history.push({
      pathname: location.pathname,
      search: `?version-id=${ versionId }`,
    });
  };

  const {
    items: versions,
    itemsLoading: versionsLoading,
    pagination,
  } = useItems(CollectionKeys.VERSIONS, {
    filterQuery: {
      'race.id_eq': race?.id,
      'device.id_eq': device?.id,
      'trait.id_eq': trait?.id,
    },
  });

  return (
    <AppTable
      columns={ tableColumns }
      paginationProps={ pagination }
      loading={ versionsLoading }
      data={ versions }
      ViewProp={ { handleView: handleViewAction } }
    />
  );
};

export default VersionSelectTable;
